import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TagsInput from 'react-tagsinput';
import Sidebar from '../components/Sidebar';
import { SOURCES, SENDER_ID } from '../config';
import * as Actions from '../models/user/actions';
import Store from '../library/M2Store';


class ProfileController extends React.Component {
    constructor(props) {
        super(props);




        let push_enabled = false;
        if(!window.initFirebase) {
            window.initFirebase = true;
            firebase.initializeApp({
                messagingSenderId: SENDER_ID
            });
        }

        this.messaging = null;

        if ('Notification' in window) {
            this.messaging = firebase.messaging();
            if (Notification.permission === 'granted') {
                push_enabled = true;
            } else {
                push_enabled = false;
            }
            let self = this;
            this.messaging.onTokenRefresh(function () {
                self.messaging.getToken().then(function(token) {
                    self.props.actions.addDevice(token);
                }).catch(function(error) {
                    console.error('error get token');
                });
            });
        }





        this.state = {
            dark_mode: (Store.get('m2darkmode') && Store.get('m2darkmode') == 'dark') ? true : false,
            tags: [],
            selected_sources: [],
            push_enabled: push_enabled,
            button_text: 'Сохранить изменения'
        };
        this.submitHandler = this.__submitHandler.bind(this);
        this.pushEnabled = this.__pushChangeHandler.bind(this);
        this.sourceUpdate = this.__sourceChangeHandler.bind(this);
    }

    __sourceChangeHandler(event) {
        let items = this.state.selected_sources;
        let val = event.target.value;
        if(items.indexOf(val) + 1 > 0) {
            items.splice(items.indexOf(val), 1);
        } else {
            items.push(val);
        }

        this.setState({selected_sources: items});
    }

    __setDarkMode(event) {
        event.preventDefault();
        let dark_mode = !this.state.dark_mode;
        if(dark_mode) {
            Store.set('m2darkmode', 'dark');
        } else {
            Store.remove('m2darkmode');
        }
        this.setState({dark_mode: dark_mode});
    }

    tagHandleChange(tags) {
        this.setState({tags: tags});
    }

    __submitHandler(event) {
        event.preventDefault();
        let info = {
            sources: this.state.selected_sources,
            tags: this.state.tags
        };
        Store.set('m2filter_sources', JSON.stringify(this.state.selected_sources));

        this.props.actions.updateProfile(info);
    }

    __subscribeUser() {
        let self = this;
        if(this.messaging) {
            this.messaging.requestPermission().then(function () {
                self.messaging.getToken().then(function (token) {
                    self.props.actions.addDevice(token);
                }).catch(function (error) {
                    Store.set('m2push_browser', 'm2push_browser');
                    alert('Ваше устройство не поддерживает push уведомления');
                });
            }).catch(function (err) {
                console.error(err);
            });
        }else {
            alert('Ваше устройство не поддерживает push уведомления');
            this.setState({push_enabled: false});
        }
    }

    __pushChangeHandler(event) {
        let push = !this.state.push_enabled;

        if(push == true) {
            this.__subscribeUser();
        }

        this.setState({push_enabled: push});
    }


    componentDidMount() {
        this.props.actions.getProfile();
    }

    componentWillReceiveProps(p) {
        if(p.answer && p.answer.state) {
            if(p.answer.state == 'FINISH_LOAD_PROFILE') {
                if(p.answer.data.result == 'success') {
                    let info = p.answer.data.info;
                    this.setState({
                        tags: info.search_strings,
                        selected_sources: info.sources
                    });
                    Store.set('m2filter_sources', JSON.stringify(info.sources));
                } else {
                    alert('Ошибка загрузки профиля');
                }
            }

            if(p.answer.state == 'ERROR_LOAD_PROFILE') {
                alert('Ошибка загрузки профиля');
            }

            if(p.answer.state == 'FINISH_UPDATE_PROFILE') {
                if(p.answer.data.result == 'success') {
                    let self = this;
                    this.setState({button_text: 'Профиль сохранен'});
                    setTimeout(function(){
                        self.setState({button_text: 'Сохранить изменения'});
                    }, 2500);
                } else {
                    alert("Ошибка обновления профиля");
                }
            }

            if(p.answer.state == 'ERROR_UPDATE_PROFILE') {
                alert("Ошибка обновления профиля");
            }
        }
    }

    render() {
        let className = ['m2controller', 'm2controller__feed', 'm2profile_controller'];

        if(this.state.dark_mode) {
            className.push('m2dark_mode');
        }

        let svg_logo = '<use xlink:href="#icon-logo"></use>';


        let items = [];
        let selected_sources = this.state.selected_sources;
        let self = this;
        SOURCES.map(function(item) {
            let selected = selected_sources.indexOf(item) + 1 > 0 ? true : false;
            items.push(
                <div className="m2profile_sources" key={"profile_source_" + item}>
                    <div className="m2checkbox2">
                        <input onChange={self.sourceUpdate} type="checkbox" checked={selected} className={selected ? "m2checked" : ""} value={item} />
                    </div>
                    <div className="m2checkbox_title">{item}</div>
                </div>
            );
        });

        let tag_input_options = {
            placeholder: 'Слово'
        };

        return (
            <div className={className.join(' ')}>
                <div className="m2sidebar">
                    <Sidebar darkmode={this.__setDarkMode.bind(this)}/>
                </div>
                <div className="m2content">
                    <div className="m2content__header">
                        <div className="header__logo">
                            <svg dangerouslySetInnerHTML={{__html: svg_logo}}></svg>
                        </div>
                    </div>
                    <div className="m2content__container m2content__full_container m2content_profile">
                        <div className="m2profile_wrapper">
                            <form method="POST" onSubmit={this.submitHandler}>
                                <div className="m2profile_row">
                                    <div className="m2profile_row_title">Источники по умолчанию</div>
                                    <div className="m2profile_sources_container">
                                        {items}
                                    </div>
                                </div>
                                <div className="m2profile_row">
                                    <div className="m2profile_row_title">Настройки push</div>
                                    <div className="m2profile_row_push_checker">
                                        <div className="ios_checker">
                                            <span>Off</span>
                                            <div className={this.state.push_enabled ? "ios_checkbox ios_checked_checkbox" : "ios_checkbox"}>
                                                <input onChange={this.pushEnabled} type="checkbox" checked={this.state.push_enabled}/>
                                            </div>
                                            <span>On</span>
                                        </div>
                                    </div>
                                    <div className="m2profile_row_tags">
                                        <div className="m2profile_row_tags_note">Введите ключевые слова и нажмите Enter</div>
                                        <TagsInput inputProps={tag_input_options} onlyUnique={true} value={this.state.tags} onChange={this.tagHandleChange.bind(this)} />
                                    </div>
                                </div>
                                <div className="m2profile_row">
                                    <button type="submit">{this.state.button_text}</button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    answer: state.UserReducer
});


const mapDispatchProps = dispatch => ({
    actions: bindActionCreators(Actions, dispatch)
});


export default connect(
    mapStateToProps,
    mapDispatchProps
)(ProfileController);



// WEBPACK FOOTER //
// ./src/controllers/ProfileController.js